import React, { memo, useContext } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { FooterSettings, surferHooks } from 'components/Record';
import { useSelector } from 'react-redux';
import { AudioEditorStyles } from '../Style';
import { Skeleton } from '@mui/material';
import { Space } from 'styles/GlobalStyle';
import { AudioEditorContext } from './AudioEditorContext';
import AudioHeader from './AudioHeader';
import '../Record.css'

const AudioEditor = ({ showSettingsBtns, actionBtns }) => {

    surferHooks.useAudioEffects(60)

    const { assessment } = useSelector(state => state.assessment)
    const { refs, state } = useContext(AudioEditorContext)
    const { containerRef, regionsPluginRef, firstDoubleClickTimeRef, tempRegionRef } = refs
    const { isAudioMarkingMode, audioRate, menuPosition, audioDuration, isLoading, selectedRegion, setIsWaitingForSecondClick, setRegionsList, setMenuPosition, setSelectedRegion } = state

    const clearAllRegions = () => {
        if (regionsPluginRef.current) {
            regionsPluginRef.current.clearRegions();
            firstDoubleClickTimeRef.current = null;
            tempRegionRef.current = null;
            setIsWaitingForSecondClick(false);
            setRegionsList([]);
        }
    };

    // סגירת התפריט
    const handleCloseMenu = () => {
        setMenuPosition(null);
        setSelectedRegion(null);
    };

    // פונקציה למחיקת המקטע הנבחר מתוך התפריט
    const handleDeleteRegion = () => {
        if (selectedRegion) {
            selectedRegion.remove(); // מחיקת המקטע מ-WaveSurfer
        }
        handleCloseMenu(); // סגירת התפריט
    }

    const audioOpacity = isLoading ? 0 : (!isAudioMarkingMode ? 0.5 : 1);
    const audioFilter = !isAudioMarkingMode && !isLoading ? 'grayscale(100%)' : 'none';

    return (
        <AudioEditorStyles>
            <AudioHeader
                id={assessment.id}
                title={assessment.reading_assessment_title}
                showSettingsBtns={!isLoading && showSettingsBtns}
                rate={audioRate}
                isAudioMarkingMode={isAudioMarkingMode}
                actionBtns={actionBtns}
            />
            <Space />
            <div className="flex aic">
                <div style={{ minWidth: '40px', fontWeight: 'bold', color: '#5F6E86' }}>
                    {isLoading ? <Skeleton variant="text" width={30} animation="wave" /> : audioDuration}
                </div>


                {/* התוכן האמיתי (מוסתר ויזואלית בעזרת opacity בזמן טעינה כדי שיוכל עדיין להתרנדר ברקע) */}
                <div className='audio' style={{ position: 'relative' }}>
                    {/* האנימציה שמוצגת בזמן שהאודיו נטען */}
                    {isLoading && (
                        <div style={{ width: "100%" }}>
                            <Skeleton variant="rectangular" width="100%" height={50} animation="wave" style={{ borderRadius: '4px', marginBottom: '10px' }} />
                            <Skeleton variant="rectangular" width="100%" height={20} animation="wave" style={{ borderRadius: '4px' }} />
                        </div>
                    )}

                    <div ref={containerRef}
                        style={{
                            opacity: audioOpacity,
                            filter: audioFilter,
                            transition: 'opacity 0.3s, filter 0.3s'
                        }}
                    />
                    <div id="timeline" style={{ opacity: isLoading ? 0 : 1, pointerEvents: isLoading ? 'none' : 'auto', }} />
                </div>
            </div>

            <FooterSettings />

            {/* תפריט MUI למחיקת המקטע */}
            <Menu
                open={menuPosition !== null}
                onClose={handleCloseMenu}
                anchorReference="anchorPosition"
                anchorPosition={
                    menuPosition !== null
                        ? { top: menuPosition.top, left: menuPosition.left }
                        : undefined
                }
            >
                <MenuItem onClick={handleDeleteRegion}>
                    {"מחיקת מקטע"}
                </MenuItem>
                <MenuItem onClick={clearAllRegions}>
                    {"מחיקת כל המקטעים"}
                </MenuItem>
            </Menu>
        </AudioEditorStyles>
    );
}

export default memo(AudioEditor);